module.exports = __webpack_public_path__ + "media/images/facebook-cover-3611f09f0b8d4087bd65bda7537803e0.png";